"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = "\n:root:root:root .bn-notify-custom * {\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n}\n";